module.exports = __webpack_public_path__ + "7d198496a33ffca3d6818d3391c5d62b.svg";


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/referral/modals/close.svg
// module id = 1027
// module chunks = 0